// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18Yyr","location":"Header_location__2di58"};